module.exports = {
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};


//# sourceMappingURL=nb-NO.main.js.map
